export function openNewTab(link) {
  window.open(link, "_blank").focus();
}
